export const TARGETS = {
  SETTINGS: 'settings'
};
